export default {
  "Footer.CompanyAddress1": "11/1 Soi PrachaRat 14",
  "Footer.CompanyAddress2":
    "Talat Khwan Subdistrict, Mueang Nonthaburi District",
  "Footer.CompanyAddress3": "Nonthaburi 11000",
  "Footer.Title": "(Address to issue documents)",
  "Footer.MailAddress1": "CW Tower, Floor 31, Tower A",
  "Footer.MailAddress2": "90 Ratchadaphisek Road, Huay Kwang",
  "Footer.MailAddress3": "Bangkok 10310",
  "Footer.ContactUs": "Contact Vecabo",
  "Footer.News": "News",
  "BOOK.NOW": "GET QUOTATION",
  "Footer.Why": "Why Vecabo?",
  FullCompanyName: "VECABO CO.,LTD.",
  HISOBUS: "Vecabo",
  Search: "Search",
  HowToPay: "How To Pay",
  PENDING: "PENDING",
  PAY: "PAID",
  CANCEL: "CANCEL",
  ONTRIP: "ONE RIP",
  DONE: "DONE",
  Baht: "THB",
  Back: "Back",
  Total: "Total",
  READMORE: "READ MORE",
  Add: "Add",
  Pay: "Pay",
  Insurer_Nanme: "Insurer Nanme",
  PAID: "Paid",
  Detail: "Detail",
  Company: "Company",
  Home: "Home",
  Name: "Name",
  Signin: "Sign in",
  Signout: "Signout",
  Register: "Register",
  Blog: "Blog",
  AbousUs: "About Us",
  BlogDetail: "Blog Detail",
  AboutUs: "About Us",
  Booking: "Booking",
  Booking2: "Booking",
  ContactUs: "Contact Us",
  HowToBooking: "How to booking",
  Service: "Service",
  Gallery: "Gallery",
  Tool: "Tool",
  VehicleManagement: "Vehicle Management",
  HowTo: "Reservation & How to pay",
  Email: "E-mail",
  TripObjective: "Trip Objective",
  Password: "Password",
  ConfirmPassword: "Confirm Password",
  ForgotPassword: "Forgot Password",
  Submit: "Submit",
  CANCEL_MODAL: "Cancel",
  EditProfile: "Edit User Infomation",
  Quotation: "Quotation by",
  Or: "Or",
  SigninWithFacebook: "Sign in with Facebook",
  SigninWithGoogle: "Sign in with Google",
  FirstName: "First Name",
  LastName: "Last Name",
  PhoneNumber: "Phone Number",
  LineId: "Line ID",
  Facebook: "Facebook",
  Address: "Address",
  notFoundData: "Not found data.",
  ViewMore: "View More",
  OtherBlog: "Other Blogs",
  MyBus: "My Bus",
  MyBooking: "My Booking",
  MyBookingDetail: "My Booking Detail",
  Next: "Next",
  Close: "Close",
  Quantity: "Quantity",
  Remove: "Remove",
  PleaseSignin: "Please signin",
  Faq: "FAQ",
  Follow: "Follow us",
  Summary: "Summary",
  Message: "Message",
  Send: "Send",
  EmailConfirm: "Email confirmed!",
  EmailConfirmContent: "You can signin to Vecabo system now.",
  EmailConfirmInvalid: "Error occured!",
  Save: "Save",
  Reset: "Reset",
  UpdateUserProfileSuccessful: "Updated user profile successful.",
  Thankyou: "Thanks You.!",
  ThankyouSec: "for choosing Vecabo.",
  UserInfo: "My profile",
  PriceStart: "Price Start",
  MyVehicles: "My Vehicles",
  seeYourTrip:
    "You will receive a quotation from us in your inbox email. We ensure you will have an amazing trip with us.",
  seeYourTripSec: "Thank you again and have a pleasant  journey.",

  // signin-validation
  "Signin.Validation.Email.Required": "Please input your emai.",
  "Signin.Validation.Email.Invalid": "Please input a valid email.",
  "Signin.Validation.Password.Required": "Please input your password.",
  // register-validation
  "register.Validation.ConfirmPassword.Required":
    "Please comfirm your password.",
  "register.Validation.ConfirmPassword.Validator": "Password must be same.",
  "register.Validation.FirstName.Required": "Please input your first name.",
  "register.Validation.LastName.Required": "Please input your last name.",
  "register.Validation.PhoneNumber.Required": "Please input your phone number.",
  "register.Validation.CompanyName.Required": "Please input your company name.",
  "register.Validation.TaxId.Required": "Please input your company Tax Id.",
  "register.Validation.CompanyAddress.Required":
    "Please input your company address.",
  "register.Validation.Branch.Required": "Please input branch.",
  "register.Validation.Country.Required": "Please input country.",
  "register.Validation.Province.Required": "Please input province.",
  "register.Validation.District.Required": "Please input district.",
  "register.Validation.SubDistrict.Required": "Please input sub-district.",
  "register.Validation.ZipCode.Required": "Please input ZipCode.",
  "register.Validation.BusinessType.Required":
    "Please input business type of your company.",
  "BusinessRegister.Success.Title": "Registration is Successful",
  "BusinessRegister.Success.Content":
    "Please wait for the contacting from the staff",
  "PartnerRequest.Success.Title": "Registration is Successful",
  "PartnerRequest.Success.Content":
    "Please wait for the contacting from the staff",
  "register.Success.ConfirmEmail":
    "Registered success, Please check/confirm your email.",
  // register-validation
  "payment.Validation.HolderName.Required": "Please input card holder name.",
  "payment.Validation.CardNumber.Required": "Please input your card number.",
  "payment.Validation.SecurityCode.Required":
    "Please input your card security code (CVV).",
  "payment.Validation.Month.Required": "Please input your card expiry month.",
  "payment.Validation.Year.Required": "Please input your card expiry year.",
  // reset-password
  "resetpassword.header.second":
    "Enter your email address and we will send you a link to reset your password.",
  "resetpassword.button.send": "Send password reset email",
  "resetpassword.Success": "Please check/confirm your email.",
  "resetpassword.confirm.Success":
    "Reset your password successful, Please signin again.",
  "resetpassword.confirm.header": "Reset you password",
  // Language-Switcher
  "langSwitcher.ChangeLanguage": "Change-Language",
  "langSwitcher.th": "Thai",
  "langSwitcher.en": "English",

  // About Us
  "aboutUs.second.title":
    "Vecabo BUS & VAN rental service that fulfill every journey",
  OurTeam: "Our Team",
  "ourteam.profile1.name": "Supakorn Kaitsangthong",
  "ourtem.profile1.position": "Founder & CEO",
  "ourteam.profile2.name": "Jeerayut Sudjarean",
  "ourtem.profile2.position": "Chief Executive Officer (CEO)",
  "ourteam.profile3.name": "Jakapan Petchann",
  "ourtem.profile3.position": "Co-Founder & CTO",
  "ourteam.profile4.name": "Kitti Pornsiwakit",
  "ourtem.profile4.position": "Co-Founder & CXO",
  "ourteam.profile5.name": "BANGKOK VENTURES",
  "ourtem.profile5.position": "Co-Founder & Advisor",
  "ourteam.profile6.name": "Waritthorn Viriyamontree",
  "ourtem.profile6.position": "Chief Technology Officer (CTO)",
  "ourteam.profile7.name": "Pawoot Pongvitayapanu",
  "ourtem.profile7.position": "Chief Strategy Officer (CSO)",
  // Booking
  "bookingDetail.Destination": "Destination",
  "bookingDetail.Payment": "Price Information",
  "bookingDetail.EditSearch": "Edit Search",
  "bookingDetail.AddBus": "Add Bus",
  "bookingDetail.AddRoute": "Add Route",
  "bookingDetail.MapRoute": "Map Route",
  "bookingPayment.From": "From",
  "bookingPayment.To": "To",
  "bookingPayment.Date": "Date",
  "bookingPayment.DateTotal": "Date Total",
  "bookingPayment.Days": "Days",
  "bookingPayment.Passenger": "Passenger",
  "bookingPayment.People": "People",
  "bookingPayment.No": "No.",
  "bookingPayment.Description": "Description",
  "bookingPayment.Units": "Units",
  "bookingPayment.Unit": "Unit",
  "bookingPayment.Price": "Price",
  "bookingPayment.Total": "Total",
  "bookingPayment.Quotation": "Quotation",
  "bookingPayment.Pay": "Pay",
  // HomePage
  "homgPage.Title": "Bus & van Rental Let‘s your trip easy & safety",
  "homePage.Reviews": "Reviews",
  "homePage.OurClients": "Our Sponsors",
  "homePage.Transmitters": "Our Transmitters",
  "homePage.Media": "Our Media Transmitters",
  "homePage.PopularDestination": "Popular Destination",
  "homePage.HowtoService": "How To Service",
  "homePage.Step1": "Step 1",
  "homePage.Step2": "Step 2",
  "homePage.Step3": "Step 3",
  "homePage.Step4": "Step 4",
  "homePage.Step1.desc": "Select Bus Type",
  "homePage.Step2.desc": "Select Destination",
  "homePage.Step3.desc": "Approved your booking",
  "homePage.Step4.desc": "Payment",
  // MyBooking
  "myBooking.header.myProfile": "My Profile",
  "myBooking.header.currentMyBooking": "My Booking",
  "myBooking.header.historyMyBooking": "My Booking History",
  // BookingFrom
  "bookingfrom.roundTrip": "Round Trip",
  "bookingfrom.oneWayTrip": "One way Trip",
  bookingfrom: "",
  "bookingfrom.bus": "Bus",
  "bookingfrom.van": "Van",
  "bookingfrom.from": "From",
  "bookingfrom.departureDate": "Departure Date",
  "bookingfrom.destination": "Destination",
  "bookingfrom.returnDate": "Return Date",
  "bookingfrom.departureTime": "Departure Time",
  "bookingfrom.returnTime": "Return Time",
  "bookingfrom.busType": "Bus Type",
  "bookingfrom.quantity": "Quantity",
  "bookingfrom.passengers": "Passengers",
  "bookingfrom.plaseSelectfrom": "Please select your origin",
  "bookingfrom.plaseSelectDepartureDate": "Please select your departure date",
  "bookingfrom.plaseSelectDestination": "Please select your destination",
  "bookingfrom.plaseSelectReturnDate": "  ",
  "booking.payment.summaryOrder": "Summary order",
  "booking.payment.summaryRouteOrder": "Summary route order",
  "book.title": "Bus & van Rental Let‘s your trip easy & safety",
  "book.checking.price": "Check Price",
  Pleasewait: "Please wait",
  // Popular Destination
  kanchanaburi: "Kanchanaburi",
  suanPhueng: "Suan Phueng",
  khaoyai: "Khao Yai",
  huahin: "Hua Hin",
  pattaya: "Pattaya",
  PartnerWithUs: "Partner with us",
  NickName: "Nick Name",
  Pricing: "Pricing",
  BusPrice1: "BUS VIP AIR",
  BusPrice2: "VAN VIP AIR",
  BusPriceSeat1: "18, 20, 25, 30 SEATS",
  BusPriceSeat2: "35 - 45 SEATS",
  BusPriceSeat3: "50 SEATS",
  BusPriceSeat4: "10 - 13 SEATS",
  VanPriceSeat1: "11 SEATS",
  VanPriceSeat2: "6 - 10 SEATS",
  VanPriceSeat3: "6 - 9 SEATS",
  ServiceHours: "Service hours",
  TenHours: "10 HOURS",
  TwelveHours: "12 HOURS",
  OTperHour: "OT per Hour",
  OTPrice1: "200 THB",
  OTPrice2: "300 - 1,000 THB",
  OTPrice3: "2,000 THB",
  limitedSpace: "Limited Space",
  bangkok: "Bangkok",
  VanPrice: "2,200 THB",
  VanPrice2: "2,800 - 11,000 THB",
  VanPrice3: "15,500 THB",
  nodata: "-",
  ServiceGasToil: "***Exclude fuel, parking fee & toll fee",
  ServiceGasToil2: "***Include fuel, parking fee & toll fee",
  price: "Price",
  distance: "Distance",
  abbkm: "km",
  km: "km",
  above: "Above",
  companyname: "Company Name",
  pricepolicy1: "The price is the price per day.",
  pricepolicy2: "Not including expressway fees",
  pricepolicy3: "Not including parking fees.",
  pricepolicy: "Price Conditions for Using Bus Services",
  ftlheader: "Bus Rental Rate",
  ftl:
    "Full Truck Load (FTL) is calculated by distance. You can see the service rates according to the type of vehicle you want to use the bus service.",
  "hisobus-sp-spacial-services": "Special Services From Vecabo",
  whyhisobus: "Why Vecabo?",
  suggestion: "Message",
  ContactNumber: "+66 96 824 8859",
  taxId: "Tax Id",
  CompanyAddress: "Company Address",
  CompanyAddress2: "Company Address 2",
  branch: "Branch",
  country: "Country",
  province: "Province",
  district: "District",
  subdistrict: "Sub-District",
  selectplaceholder: "--- Select ---",
  zipcode: "Zip Code",
  businesstype: "Business Type",
  contactNumber: "Contact Number",
  inviteCode: "Invite Code",
  businessRegister: "Registration for Business",
  InputBusiness: "Fill in company information",
  bookingStep0: "Search Bus",
  bookingStep1: "Select Bus",
  bookingStep2: "Check Information",
  bookingStep3: "Make a payment",
  scb: "Siam Commercial Bank",
  accountNumber: "Account Number",
  Services: "Services",
  InfoMation: "Infomation",
  Tel: "Tel",
  why1: "Secured",
  why2: "Standard Rate",
  why3: "Various Type of Bus",
  why4: "Passengers",
  why4_2:
    "More than 1 million 500,000 people join in the journey with buses and vans with Vecabo, and more than 98% of them are confident in choosing Vecabo.",
  why5: "Trips Served",
  why5_2:
    "Vecabo is participate in with people and traveling with more than 30,000 + bus rentals service travel trips",
  why6: "of Experienced",
  why6_2:
    "Vecabo has a bus rental operator who has been in the bus rental business for over 30 years more than in platform",
  why7: "of km Traveled",
  why7_2:
    "Vecabo joins the road trip with more than ten million kilometers of people, so we have a long experience. Where? Our roads, buses go everywhere",
  whydetail1:
    "Vecabo put travel safety as our high priority. We have assembled an effective speed control technology in every of our buses to ensure safety. Drivers also have been given special training.",
  whydetail2:
    "Bus rental fee will be calculated according to the distance. Even with a limited budget, customers can enjoy traveling by our service.",
  whydetail3:
    "Vecabo have over 2000 cars with various types ready to service according to customers' wonderful journey. ",
  whydetail4:
    "24/7 Bus Rental Service. Not over 5 minutes, Pick preferred bus at any time and get ready for the trips.",
  whydetail5: "1,500,000+",
  service1: "College Trip",
  service2: "Company Trip",
  service3: "Field Trip",
  service4: "Honeymoon & Family Trip",
  service5: "Merit Trip",
  service6: "School Trip",
  service7: "One-Day Trip",
  service8: "Company Seminar Trip",
  service9: "Sport Trip",
  transmitter:
    "And there are more companies and organizations that are talking about us, such as GSB SMEs StartUp, Panus Thailand, Thai Rath TV, Thansettakij Newspaper of Ministry of Industry, Department of Industrial Promotion, Tourism Council Of Thailand , BusinessLinX GlobalLinker and ATTM",
  media: "Here's our media",
  remarksPetrol: "Includes petrol",
  remarksExpressWay: "Excludes express way and parking fees",
  remarksDriver: "Includes full service form drivers and assistants",
  air: "Air conditioner",
  busDriver: "Bus driver",
  toilet: "Toilet",
  usb: "Usb charger",
  safetyBelt: "Safety Belt",
  electricMassageSeat: " Electric Massage Seat",
  lcdTV: "LCD TV",
  specialService: "Special Service",
  electroacoustics: "Electroacoustics",
  gpsTracking: "GPS Tracking",
  facilities: "Facilities",
  remarks: "Remarks",
  includesVat: "Include VAT",
  excludesVat: "Exclude VAT",
  addToWishlist: "Add to list",
  bestDeals: "Best deals",
  cheapest: "Cheapest",
  recommendForYou: "Recommend",
  vehicles: "Vehicles",
  defaultBusType: "Select Bus",
  seat: "Seat",
  bus: "Bus",
  people: "Passengers",
  yourBuses: "Your Bus",
  yourVans: "Van Rental Service with Driver",
  vanDriver: "Van Driver",
  yourRecommendBuses: "Recommend For You",
  busSelected: "Bus Selected",
  loading: "Please Wait...",
  tripchecking: "Check Booking Information",
  loginrequired: "Please Register or Login to Continue",
  confirmbooking: "Confirm Information",
  yourbusdetail: "Your Vehicles Detail",
  bookerdetail: "Client Detail",
  paymentoption: "Payment Option",
  onlinebanking: "Online Banking",
  totalprice: "Total Price",
  vat: "VAT",
  netprice: "Net Price",
  deposit: "Total Deposit",
  withat: "With @ in front",
  sendinvoice:
    "After the transaction is successful, inform the payment by send the transaction record to",
  copyright: "Copyright",
  partnertitle:
    "Opportunity to generate new revenue for bus and van operators. Apply now!",
  informinvoice: "Send Transfer Record",
  bookingbackalert: "Your booking is successful! Thank you for using Vecabo",
  bookingbackalert2:
    "You can verify your booking at 'My Booking' or book again at 'Booking'",
  creditcard: "Credit/Debit Card",
  cardnumber: "Card Number",
  expirydate: "Expiry Date",
  expirydate2: "MM / YY",
  confirmpayment: "Confirm Payment",
  fullPayment:
    "Reserves the right to pay in full amount When paying via credit card",
  tooltipStop: "You can create a travel plan here.",
  customerservice: "Customer Service",
  complain: "Complain",
  busstandard: "Bus Standard",
  workinghour: "Monday - Friday 09.00 - 18.00",
  complainpolicy: "Complain Policy",
  busstandardscreen: "Standard for Bus Service Provider Screening",
  aboutUs: "About us",
  promocode: "Promotion Code",
  apply: "Apply",
  discount: "Discount",
  "Staycation Time": "Staycation Time",
  "Feel Fun! One Day Trip Time": "Feel Fun! One Day Trip Time",
  "Feel Fun! Friend Group Time": "Feel Fun! Friend Group Time",
  "Feel Fun! Outing Time": "Feel Fun! Outing Time",
  "Feel Fun! Merit Time": "Feel Fun! Merit Time",
  "Feel Fun! School Trip Time": "Feel Fun! School Trip Time",
  booking_period: "Booking period",
  today: "today",
  travel_time: "Travel period",
  travel_code: "Your Travel Coupon Code",
  apply_to: "Apply at check out",
  how_to_get: "How to Get",
  condtion_term: "Terms and Conditions",
  coupon_term: "Coupon Terms and Conditions",
  "homePage.promotion": "Promotions",
  "blog.blog3.title": "ขับรถเที่ยวใกล้กรุงเทพฯ 7 ทริป ชิลๆ ไปเช้ากลับเย็น",
  Customer: "Our clients",
  ShouldInputYouPhonenumber: "Should enter your phone number",
  personal: "Personal",
  corporation: "Corporation",
  insurance: "Insurance",
  assurer: "Assurer",
  Add_Assurer: "Add Assurer",
  insurance_company: "Insurance company",
  datesday: "Please specify your day of birth",
  datesmonth: "Please specify your month of birth",
  datesyear: "Please specify your year of birth",
  date: "DD-MMM-YYYY",
  dateday: "Day",
  datemonth: "Month",
  dateyear: "Year",
  sex: "Sex",
  age: "Age",
  ethnicity: "Ethnicity",
  nationality: "Nationality",
  "register.Validation.sex.Required": "Please enter gender",
  "register.Validation.ethnicity.Required": "Please specify your ethnicity.",
  "register.Validation.nationality.Required": "Please specify nationality",
  male: "Male",
  female: "Female",
  other: "Other",
  "blog.blog16.title": "9 ที่เที่ยวหน้าหนาว ขับรถชิล ๆ ใกล้กรุงเทพฯ นิดเดียว",
  "assurer.pleasefillouttheform": "Please fill out the form",
  Mr: "Mr",
  Mrs: "Mrs",
  Ms: "Ms",
  Master: "Master",
  Miss: "Miss",
  Prefix: "Prefix",
  "register.Validation.Prefix": "Please input prefix",
  Identification_Number: "Identification Number",
  "register.Validation.Identification.Number":
    "Please input identification number.",
  employee: "รถรับส่งพนักงาน",
  contactname: "Contact Name",
  "register.Validation.contactname": "Please input contact name",
  pickuppoint: "Pick up point",
  "register.Validation.pickuppoint": "Please input pick up point",
  deliverypoint: "Delivery point",
  "register.Validation.deliverypoint": "Please input delivery point",
  passenger: "Number of passengers",
  "register.Validation.passenger": "Please input number of passengers",
  contactMore: "Contact us!",
}



// WEBPACK FOOTER //
// ./src/languageProvider/locales/en_US.ts